import React, { Component } from 'react';
import platform from 'Pub/js/platform';
import { DragSource } from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { connect } from 'react-redux';

import { processClass } from './util';

const { NCTree, NCIcon } = platform.base;
const cardSource = {
	canDrag(props) {
		//一拖入的不能够在拖拽
		return !props.movedItem
	},
	beginDrag(props) {
		let { targetAreaID, selectedNodes, currentArea } = props;
		document.body.classList.add('dragging-meta-tree');
		let currentAreaCode = processClass(currentArea.code);

		let areaDom = document.querySelector(`.search-area-${currentAreaCode}`);
		areaDom && areaDom.classList.add('area-can-drop-meta');
		props.areaList.forEach(item => {
			let maskDom = document.createElement('div');
			let itemCode = processClass(item.code);
			maskDom.classList.add('mask');
			let areaDomClass = `.drag-mask-${itemCode}`;
			let areaDom = document.querySelector(areaDomClass);
			if (itemCode === currentAreaCode) {
				return
			}

			if (currentArea.areatype === '1' && currentArea.relationcode === itemCode) {
				let contentDom = document.querySelector(`.drag-mask-content-${itemCode}`);
				contentDom.appendChild(maskDom);
			} else if (areaDom) {
				areaDom.appendChild(maskDom);
			}

			maskDom.addEventListener('dragenter', () => {
				maskDom.classList.add('mask-bg-color')
			});

			maskDom.addEventListener('dragleave', () => {
				maskDom.classList.remove('mask-bg-color')
			});

		});

		selectedNodes = selectedNodes.map(item => {
			return { props: { dataRef: item.props.dataRef } }
		});

		return {
			dataRef: props.dataRef,
			metaTree: 'metaTree',
			selectedNodes,
			targetAreaID
		};
	},
	isDragging(props, monitor) {
		return monitor.getItem().id === props.id;
	},
	endDrag(props) {
		let { currentArea } = props;
		let currentAreaCode = processClass(currentArea.code);
		document.body.classList.remove('dragging-meta-tree');
		let areaDom = document.querySelector(`.search-area-${currentAreaCode}`);
		areaDom && areaDom.classList.remove('area-can-drop-meta');

		props.areaList.forEach(item => {
			let { currentArea } = props;
			let itemCode = processClass(item.code);
			let areaDomClass = `.drag-mask-${itemCode}`;
			let areaDom = document.querySelector(areaDomClass);

			if ((item.areatype === '1' || item.areatype === '2') && currentArea.relationcode === itemCode) {
				areaDom = document.querySelector(`.drag-mask-content-${itemCode}`)
			}

			if (areaDom) {
				let maskDom = areaDom.lastElementChild;
				if (maskDom.className.includes('mask')) {
					areaDom.removeChild(areaDom.lastElementChild)
				}
			}

		});
	}
};

@DragSource('card', cardSource, (connect, monitor) => ({
	connectDragSource: connect.dragSource(),
	connectDragPreview: connect.dragPreview(),
	isDragging: monitor.isDragging(),
	getDropResult: monitor.getDropResult()
}))
class DraggableTreeNode extends Component {
	componentDidUpdate(prevProps, prevState, snapshot) {
		let { getDropResult, initState } = prevProps;
		if (getDropResult && getDropResult.result) {
			initState()
		}
	}

	componentDidMount() {
		this.props.connectDragPreview(getEmptyImage(), {
			captureDraggingState: true
		});
	}
	render() {
		let { connectDragSource, title } = this.props;

		return connectDragSource(
			<div
				style={{ display: 'inline-block' }}
			>
				{title}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		areaList: state.zoneSettingData.areaList
	};
}



export default connect(
	mapStateToProps
)(DraggableTreeNode)
